import React, { Component } from "react";
import * as API from "./api.js";
import "./style.css";
import Map from "./MapComponent.js";
import VideoPlayer from "./VideoPlayer.js"
import allFeedsButton from './icons/allFeedsButton.png';
import max from './icons/liveFeedmax.png'
import { addUserAnalytic, checkSubscriptionAndStorage, Popup, updateOutTime } from './ReusableComponents/reusableFunctions'
import { getActiveTeam } from './Teams/index.js';
import SubscriptionExpireModal from "./subscription/Reusable/SubscriptionExpireModal.js";
import AppConstants, { FEATURE_NOT_AVAILABLE_FOR_FREE_USERS_MESSAGE } from "./AppConstants.js";
import LoaderComponent from "./ReusableComponents/LoaderComponent.js";
import DroneWithBg from "./icons/DroneWithBg.svg"
import Select from "react-dropdown-select";
import { connect } from "react-redux";
class DCCAllDrones extends Component {
  state = {
    user: {},
    type: "",
    loading: true,
    recentReplaySidebar: true,
    dronesLoading: true,
    title: "ALL",
    drones: {},
    mini: false,
    outId: "",
    showSubscriptionExpirePopup: false,
    onlineDrones: []
  };

  changeDrone = (drone) => {
    if (drone) window.open("/aerogcsenterprise/drone_control_center/fly_view?drone=" + drone, '_blank');
  }
  componentWillUnmount() {
    updateOutTime(this.state.outId)
    clearInterval(this.interval)
    clearInterval(this.checkStatusInterval)
  }

  componentWillMount() {
    document.title = "Drone Control Center - All Available Drones - AeroGCS";
    
    
    getActiveTeam().then(activeTeam => {
      this.setState({
        activeTeam
      }, () => {
        addUserAnalytic(this.props.location.pathname).then(id => this.setState({ outId: id }))
        checkSubscriptionAndStorage(AppConstants.SERVICES.AEROGCS).then(data => {
          if (data.error || data.storageExceed || data.subscriptionExpire || !data.isValidStoragePlan || data.isExpired) this.setState({ showSubscriptionExpirePopup: { ...data, user: this.props?.location?.state?.user } });
          else this.setState({ showSubscriptionExpirePopup: false, infoPopup: true });
        })

        if (this.props.isFreePlan){
          return Popup.alert("WARNING_NOTE",FEATURE_NOT_AVAILABLE_FOR_FREE_USERS_MESSAGE,() => {
          this.props.history.push("/aeroGCS_plans", { user : this.props.location.state.user, serviceName: "AeroGCS Enterprise", currentPlan: this.props.location.state.user.sub });
        }, () => {
          return this.setState({loading: false})
        })
        }

        if (this.props && this.props.location && this.props.location.state) {
          this.setState((prevState) => ({
            ...prevState,
            user: this.props.location.state.user,
            type: this.props.location.state.type,
            sidebarMode: this.props.location.state.sidebarMode,
          }), () => {
            this.getPageData();
            this.setStatusInterval();
          });
        } else {
          API.getUserType().then(([blah, type, user]) => {

            this.setState((state) => ({
              ...state,
              user,
              type,
              sidebarMode: "shrunk"
            }), () => {
              this.getPageData();
              this.setStatusInterval();
            })
          }, (e) => {
            window.location.replace("/login");
          })
        }
      })
    })

  }

  setStatusInterval = () => {
    this.checkStatusInterval = setInterval(() => {
      this.getPageData()
    }, 60000)
  }


  getPageData = () => {
    API.GetAllDronesStatus().then(async allDrones => {
      let allDronesObject = {};
      let onlineDrones = []
      await allDrones.drones.forEach(drone => {
        if (drone.id && drone.online == true) {
          onlineDrones.push({
            ...drone,
            droneName: drone.drone_name,
            streamURL: `${drone?.uri && drone?.stream_key ? `https://${drone.uri}/streams/${drone?.stream_key}.m3u8` : ''}`,
          })
        }
        allDronesObject[drone.drone_id] = {
          ...drone,
          droneName: drone.drone_name,
          streamURL: `${drone?.uri && drone?.stream_key ? `https://${drone.uri}/streams/${drone?.stream_key}.m3u8` : ''}`,
        }
      })
      this.setState({ dronesLoading: false, onlineDrones: onlineDrones, drones: allDronesObject, loading: false, })

    }).catch(error => {
      try {
        console.log(JSON.stringify(error));
      } catch (e) {
        console.log(error);
      }
    })
  }



  render() {
    let { user, type, sidebarMode, recentReplaySidebar } = this.state;
    let isDroneLive = this.state.onlineDrones.length > 0
    return (
      <div className="wrapper"
        style={{ overflowY: "hidden" }} >
        <div
          className="right-content-new"
          style={{ height: "100vh", overflowY: "auto", left: "0px", width: "100vw" }}
        >
          {/*  */}
          {
            this.state.showSubscriptionExpirePopup ?
              <SubscriptionExpireModal
                data={this.state.showSubscriptionExpirePopup}
              /> : <></>
          }
          <div className="top-bar-new">
            <div className="top-bar-text-new">Drone Control Center - All Available Drones</div>
          </div>
          {this.state.loading ? <LoaderComponent /> :
            <div className="main-content main-content-dcc" style={{ paddingTop: "1px", paddingLeft: "0px", paddingRight: "0px", display: "flex", }}>
              {this.state.activeTeam.isOwner ? <>
                <Map
                  className="dcc-all-drones-map"
                  drones={this.state.drones}
                  showIcons={true}
                  includePortsInRecenter={true}
                  recenterMap={true}
                  control={true}
                  markerClickCallback={(drone) => {
                    window.open("/aerogcsenterprise/drone_control_center/fly_view?drone=" + drone, '_blank');
                  }}
                />
                <div className="droneLiveCountNumber" style={{ backgroundColor: isDroneLive ? '#238E28' : '#868F9C' }}>{
                  this.state.onlineDrones.length}</div>
                <img src={DroneWithBg} className="droneLiveCount" />
                <div className="droneLiveSelect">
                  <Select
                    placeholder="Select Drone"
                    searchable={true}
                    noDataRenderer={() => {
                      return <span style={{ textAlign: 'center', padding: '5px 0px' }}>Drones not available</span>
                    }}
                    options={
                      this.state.onlineDrones.map((drone, i) => ({
                        label: `${drone.uin} (${drone.drone_name})`,
                        value: drone
                      }))
                    }
                    className="custom_dropdown"
                    onChange={(e) => {
                      if (e.length > 0) {
                        this.changeDrone(e[0]?.value?.drone_id)
                      }
                    }
                    }
                  />
                </div>
                <div className="dcc-all-drones-live-feeds">
                  <div className="dcc-all-drones-live-feeds-header">
                    <span className="dcc-all-drones-live-feeds-header-text">
                      Live Feeds
                    </span>
                    <span className="dcc-all-drones-live-feeds-header-button">
                      {Object.keys(this.state.drones).length == 0 ? <></>
                        : <img className="dcc-all-drones-live-feeds-header-button-img" style={{ cursor: isDroneLive ? undefined : "not-allowed", filter: isDroneLive ? '' : 'grayscale(100%)' }} src={max} onClick={() => { if (isDroneLive) this.setState({ mini: !this.state.mini }) }} />}
                      <img className="dcc-all-drones-live-feeds-header-button-img" style={{ cursor: isDroneLive ? undefined : "not-allowed", filter: isDroneLive ? '' : 'grayscale(100%)' }} src={allFeedsButton} onClick={() => { if (isDroneLive) window.open("/aerogcsenterprise/drone_control_center/all_feeds", '_blank'); }} />
                    </span>
                  </div>
                  <div className="dcc-all-drones-live-feeds-grid">
                    {
                      this.state.onlineDrones.map((drone, i) => (
                        <React.Fragment>
                          {drone.online && this.state.mini ? <VideoPlayer droneName={drone?.drone_name} streamKey={drone.stream_key} url={drone.streamURL} /> : <div />}
                        </React.Fragment>
                      ))
                    }
                  </div>
                </div>
              </> : <div style={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center", height: "75vh" }}>
                {`You dont have access to drone control center of ${this.state.activeTeam?.teamName} `}
              </div>}
            </div>
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isFreePlan: state.subscription.isFreePlan
  };
};

export default connect(mapStateToProps)(DCCAllDrones)